module.exports = __webpack_public_path__ + "images/excel-logo-1.png";